// list of locales supported by backend
// _email_locales = {
//   "de_DE": BookingMailLocale.DE,
//   "de_CH": BookingMailLocale.DE,
//   "de_AT": BookingMailLocale.DE,
//   "en_US": BookingMailLocale.EN,
//   "en_GB": BookingMailLocale.EN,
//   "en_AU": BookingMailLocale.EN,
//   "en_DE": BookingMailLocale.EN,
//   "en_AT": BookingMailLocale.EN,
//   "en": BookingMailLocale.EN,
//   }

import { getDomainExtension } from './getDomainExtension'

export const getLocaleForAdyen = (lang: string): string => {
    if (lang === 'de-CH') return 'de_CH'
    if (lang === 'de-AT') return 'de_AT'
    if (lang === 'de-DE') return 'de_DE'
    // if(lang === 'de_DE') return 'de_DE'
    const domain = getDomainExtension()
    if (domain === 'com') {
        if (lang === 'de') return 'en_DE'
        if (lang === 'en') return 'en_GB'
    }

    return `${lang}_${domain.toUpperCase()}`
}
